import React from "react";
import Lottie from "react-lottie-player";
import LoadingAnimation from "./loading.json";
import "./Spinner.scss";
export const Spinner = () => {
    return (React.createElement("div", { className: "lysa-ui-spinner" },
        React.createElement(Lottie, { animationData: LoadingAnimation, play: true, loop: true, className: "spinner-container" })));
};
